import low from 'lowdb';
import LocalStorage from 'lowdb/adapters/LocalStorage';
var adapter = new LocalStorage('cyy-manage');
var db = low(adapter);
db.defaults({
  sys: {},
  database: {}
}).write();
export default db;